<template>
  <div>
    <div class="header">
      <div class="logobox"><img class="logoimg" src="../assets/img/logo.png" alt=""/></div>
    </div>
    <div class="login-wrap">
    <div class="login-form">
      <div class="title">
      </div>
      <div class="logo-title">
        <h1>登录山魈市场检测系统</h1>
      </div>
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm login-container">
        <el-form-item prop="username" label="" style="margin-top: 60px">
          <el-input type="text" prefix-icon="el-icon-user" v-model="ruleForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="" style="margin-top: 50px">
          <el-input type="password" prefix-icon="el-icon-lock" @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.password" auto-complete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center;margin-top: 45px">
          <el-button class="btn-add" type="primary" @click="submitForm('ruleForm')" :loading="logining">登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {login} from '../api/userMG'
  import {setToken} from '../utils/token'
  import {setCookie} from "../utils/util";

  export default {
    name: 'login',
    data() {
      return {
        //定义loading默认为false
        logining: false,
        // 记住密码
        rememberpwd: false,
        ruleForm: {
          //username和password默认为空
          username: '',
          password: '',
        },
        //rules前端验证
        rules: {
          username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
          password: [{required: true, message: '请输入密码', trigger: 'blur'}]
        }
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      // 获取存在本地的用户名密码nnpm
    },
    // 里面的函数只有调用才会执行
    methods: {
      submi() {
        this.$router.push({
          path: '/home,'
        })
      },
      //获取info列表
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.logining = true
            this.$store.dispatch('Login', this.ruleForm).then((res) => {
              if (res.errno === 0) {
                this.logining = false;
                this.$message({
                  type: "success",
                  message: '登录成功'
                })
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.$router.push({path: '/home/rangking'})
                  })
                }, 1000)
              } else {
                this.$message.error(res.error)
                this.logining = false
              }
            }).catch(() => {
              this.logining = false
            })
          } else {
            // 获取图形验证码
            this.$message.error('请输入用户名密码！')
            this.logining = false
            return false
          }
        })
      },
    },
  }
</script>

<style scoped>
.header{
  display: flex;
}
.logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: left;
    padding: 10px 0px;
    overflow: hidden;
    background-color: #1f2334;
    width: 100%;
  }
  
  .logo-title{
    width: 800px;
    text-align: center;
  }
  .title{
    /*background: url("../assets/img/logo.png") center no-repeat;*/
    /*background-size: contain;*/
    margin: 0 auto;

  }

  .logo-title h1{
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    letter-spacing: 5px;
    text-align: center;
  }
  .logo-title h4{
    width: 626px;
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    margin: 0 auto;
  }
  .login-wrap {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    /*background: url("../assets/img/bg.jpg");*/
    /*background-repeat: no-repeat;*/
    /*background-position: center;*/
    /*background-size: cover;*/
  }

  .login-form {
    align-items: center;
    margin: 0 auto;
    margin-top: 5%;
  }

  .login-container {
    /* border-radius: 5px; */
    width: 50%;
    margin: 0 auto;
    padding: 80px 25px;
    /* border: 1px solid #eaeaea; */
    text-align: left;
    /* box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1); */
    background: #fff;
  }

  .el-form{
    width: 65%;
    /* height: 50%; */
    padding: 0;
    margin: 0 auto;
    margin-top: 6%;
  }
  .el-input{
    font-size: 18px;
  }
  .login-form >>> .el-input__inner{
    width: 480px;
    height: 43px;
    border-radius: unset;
    border: 1px solid #cccccc;
    font-size: 16px;
  }
  .login-form >>> .el-input__inner:focus{
    border: 1px solid #1d94ee;
  }
  .login-form >>> .el-form-item__label{
    font-size: 20px;
  }
  .login-form >>> .el-form-item{
    padding: 0 20px;
  }
  .login-form >>> .el-button {
    width: 480px;
    height: 50px;
    padding: 0;
    font-size: 22px;
    background-color: #49a6ff;
    border: none;
  }
  .login-form >>> .el-button:hover{
    width: 480px;
    height: 50px;
    padding: 0;
    font-size: 22px;
    color: #d8e6fa;
    background-color: #4397ec;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue